import React from 'react';
import './Notification.css';

function Notification({ message, type, onClose }) {
  return (
    <div className={`notification ${type}`}>
      <span>{message}</span>
      <button onClick={onClose}>&times;</button>
    </div>
  );
}

export default Notification;